import 'react-app-polyfill/ie11';
import "@babel/polyfill";
import "url-polyfill"
import registerServiceWorker from './registerServiceWorker';
import React from 'react'
import { render } from 'react-dom'
import App from './App'
import Dashboard from './Components/Dashboard'
import NewAppointment from './Components/NewAppointment'
import LandingPage from './Components/LandingPage'
import LoginForm from './Components/LoginForm'
import CreateAccount from './Components/CreateAccount.js'
import SelectVehicle from './Components/SelectVehicle'
import PrivateRoute from './Components/PrivateRoute.js';
import './CSS/Template.css'
import { CookiesProvider } from 'react-cookie';
import {StripeProvider} from 'react-stripe-elements';
import {StripeApiKey} from './utils/ApiKeys.js'

import {
  BrowserRouter as Router,
  Link,
  Switch,
  Route // for later
} from 'react-router-dom'

 render((

  <StripeProvider apiKey={StripeApiKey()}>
    <CookiesProvider>
      <Router>
        <Switch>
          <Route exact path ="/landing" component={LandingPage}/>
          <Route exact path ="/login" component={LoginForm}/>
          <Route exact path ="/createAccount" component={CreateAccount}/>
          <Route exact path = "/*" component={App}/>
        </Switch>
      </Router>
    </CookiesProvider>
  </StripeProvider>
), document.getElementById('root'));

registerServiceWorker();




// WEBPACK FOOTER //
// ./src/index.js